import React, { useEffect, useRef, useState } from 'react';
import { Card, Badge, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Sindhura from '../../../../Assets/Images/Sindhura.png';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import Alphonso from '../../../../Assets/Images/Alphonso.png';
import Strawberry from '../../../../Assets/Images/Strawberry.png';
import BlackGrapes from '../../../../Assets/Images/BlackGrapes.png';
import Carousel from "react-multi-carousel";
import { title } from 'process';
import TextTestimonials from './TextTestimonials';
import { FruitCardresponsive, Testimonialsresponsive } from "../Helpers/Responsive";
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';



function FarmerTestimonialsComponent(props) {

    const carouselRef: any = useRef(null);
    

    var testimonialsData = props.data;
    const [currentSlide, setCurrentSlide] = useState(0);

    const handleNext = () => {
        carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide + 1;
        if (((carouselRef.current.state.currentSlide) + (carouselRef.current.state.slidesToShow)) > carouselRef.current.state.totalItems) {
            carouselRef.current.state.currentSlide =  carouselRef.current.state.currentSlide -1 
            return;
        }
        const nextSlide = carouselRef.current.state.currentSlide;
        setCurrentSlide(nextSlide);
        carouselRef.current.goToSlide(nextSlide);       
    };

   

    const handlePrev = () => {
        if (carouselRef.current.state.currentSlide == 0){
            return;
        }
        const prevSlide = carouselRef.current.state.currentSlide - 1;
        setCurrentSlide(prevSlide);
        carouselRef.current.goToSlide(prevSlide);
    };

    const handleNextMobile = () => {
        carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide + 1;
        if (((carouselRef.current.state.currentSlide) + (carouselRef.current.state.slidesToShow)) == carouselRef.current.state.totalItems) {
            carouselRef.current.state.currentSlide = carouselRef.current.state.currentSlide - 1;
            return;
        }
        const nextSlide = carouselRef.current.state.currentSlide;
        carouselRef.current.goToSlide(nextSlide)
       
       
    };

    const  handlePrevMobile = () => {    
        if((carouselRef.current.state.currentSlide) < 1){
            return;
        }

        const prevSlide  = carouselRef.current.state.currentSlide - 1;
        carouselRef.current.goToSlide(prevSlide);
    }
    

    return (

        <Container>
            <div className='row'>
                <div className='col-lg-4 col-12 col-xl-3 '>
                    <h1 className='fw-bold mb-4' style={{fontSize:'42px'}}>{props.Heading}</h1>
                    <p className='fw-bold mb-4 mb-lg-5'>{props.SubHeading} </p>
                    <div className='d-none d-lg-flex justify-content-evenly '>
                        <FontAwesomeIcon icon={faArrowLeftLong} className='fa-2xl' style={{cursor: ' pointer'}} onClick={handlePrev} />
                        <FontAwesomeIcon icon={faArrowRightLong} className='fa-2xl' style={{cursor: ' pointer'}} onClick={handleNext} />
                    </div>
                </div>
                <div className='col-lg-8 col-12 col-xl-9 ps-lg-0' >
                    <Carousel
                        responsive={Testimonialsresponsive}
                        ssr
                        ref={carouselRef}
                        arrows={false}
                        draggable={false}
                        swipeable={false}
                    >
                        {testimonialsData != null && testimonialsData.length > 0 && testimonialsData.map((item, index) => (
                            <div key={index} className=' ps-2 ps-lg-0 pe-2 mb-2 '>
                                <TextTestimonials item={item} />

                            </div>
                        ))}
                    </Carousel>
                </div>

                <div className='col-12 ps-4 d-lg-none'>
                    <div className=' mt-4 '>
                        <FontAwesomeIcon icon={faArrowLeftLong} className='fa-2xl pe-4' style={{cursor: ' pointer'}} onClick={handlePrevMobile} />
                        <FontAwesomeIcon icon={faArrowRightLong} className='fa-2xl ' style={{cursor: ' pointer'}} onClick={handleNextMobile} />
                      
                        
                    </div>
                </div>
            </div>

        </Container>




    );


}

export default FarmerTestimonialsComponent; 